import { FC } from 'react';
import { SanityImage } from '@/lib/sanityImage';

import type { Project } from '@/types';
import { IconLink } from './IconLink';

interface Props {
  project: Project;
}

const ProjectCard: FC<Props> = ({ project }) => {
  return (
    <article
      key={project._id}
      className="flex flex-col border-b-2 border-gray-200"
    >
      <h3>{project.title}</h3>
      <figure className="overflow-hidden m-0 rounded h-[150px] grow md:grow-0">
        <SanityImage source={project.mainImage} />
      </figure>
      <p className="mt-0 grow">{project.description}</p>
      <div className="flex gap-4 justify-end mb-2">
        {project.liveLink && <IconLink url={project.liveLink} type={'web'} />}
        {project.githubLink && (
          <IconLink url={project.githubLink} type={'github'} />
        )}
      </div>
    </article>
  );
};

export default ProjectCard;
